import {
    GET_MENU_CATEGORIES, HIDE_GIFT_ITEM, HIDE_MENU_ALERT,
    HIDE_MENU_CATEGORY_ALERT,
    HIDE_MENU_ITEM, SHOW_GIFT_ITEM, SHOW_MENU_ALERT,
    SHOW_MENU_CATEGORY_ALERT,
    SHOW_MENU_ITEM
} from '../actions/menu.actions';

const initialState = {
    categories: [],
    selectedItem: null,
    selectedGiftItem: null,
    selectedGift: null,
    disabledCategory: null,
    alert: {
        isShow: false,
        title: '',
        body: '',
    }
};

const MenuReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_MENU_CATEGORIES:
            return {
                ...state,
                categories: action.payload
            };
        case SHOW_MENU_ITEM:
            return {
                ...state,
                selectedItem: action.payload
            };
        case HIDE_MENU_ITEM:
            return {
                ...state,
                selectedItem: null
            };
        case SHOW_MENU_CATEGORY_ALERT:
            return {
                ...state,
                disabledCategory: action.payload
            };
        case HIDE_MENU_CATEGORY_ALERT:
            return {
                ...state,
                disabledCategory: null
            };
        case SHOW_GIFT_ITEM:
            return {
                ...state,
                selectedGiftItem: action.payload.item,
                selectedGift: action.payload.gift
            };
        case HIDE_GIFT_ITEM:
            return {
                ...state,
                selectedGiftItem: null,
                selectedGift: null
            };
        case SHOW_MENU_ALERT:
            return {
                ...state,
                alert: {
                    ...state.alert,
                    isShow: true,
                    body: action.payload
                }
            };
        case HIDE_MENU_ALERT:
            return {
                ...state,
                alert: {
                    ...state.alert,
                    isShow: false
                }
            };
        default:
            return state;
    }
};

export default MenuReducer;